import React, { useState } from 'react'
import { SortSelect } from 'components/SortSelect'

const SORT_OPTIONS = [
  { value: 'name_asc', label: 'Name A→Z' },
  { value: 'name_desc', label: 'Name Z→A' },
  { value: 'date_desc', label: 'Newest first' },
  { value: 'date_asc', label: 'Oldest first' },
]

export function SortSelectMock(): React.ReactElement {
  const [value, setValue] = useState(SORT_OPTIONS[2])
  return (
    <div className="w-48">
      <SortSelect
        options={SORT_OPTIONS}
        value={value}
        onChange={(v) => setValue(v as typeof value)}
      />
    </div>
  )
}
